import { render, staticRenderFns } from "./GeoPointField.vue?vue&type=template&id=0b85c25f&scoped=true&"
import script from "./GeoPointField.vue?vue&type=script&lang=js&"
export * from "./GeoPointField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85c25f",
  null
  
)

export default component.exports
import {QInput,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QInput,QBtn,QTooltip}, component.options.components || {})
